<script>

import ExhibitorRow from "./exhibitor-row.vue"
import ExhibitorNavbar from "./exhibitor-navbar.vue"
import FavoriteMixin from "./favorite-mixin.js"
import PaginationButtons from "../pagination-buttons.vue"

export default {
  components: {ExhibitorNavbar, ExhibitorRow, PaginationButtons},
  mixins: [FavoriteMixin],
  props: {
    eventShortName: {type: String },
    listDisplay: {type: Boolean, default: true},
    },

  data() {
    return {
      filter: {},
      currentNode: null,
      tree: null,
      loading: false,
      exhibitors: [],
      numExhibitors: 0,
      numVisitedExhibitors: 0,
      numPages: 0,
      page: this.$route.query.page || 1,
    }
  },

  computed: {
    favoriteMode() {
      return this.eventShortName == undefined && !this.$route.query.visits || !navigator.onLine
    },
    favActive() { return this.filter.favorites },
    visitsActive() { return this.filter.visits },
    itemKey() { return `${this.exhibitorType}s` }
  },

  watch: {
    filter: {
      handler(newValue) {
        this.page = 1
        this.filter = newValue
        this.fetchExhibitors(newValue)
        let query = this.filter.search ? {search: this.filter.search} : {}
        if (this.filter.company__name__gt)
          query.company__name__gt = this.filter.company__name__gt
        if (this.filter.favorites)
          query.favorites = "1"
        if (this.filter.visits)
          query.visits = true
        this.$router.push({query: query}).catch(err => {
          // catch NavigationDuplicated
          console.error(err)
        });
      },
      deep: true
    },
    page: {
      handler(newValue) {
        this.fetchExhibitors({page: newValue, ...this.filter})
        // persist page in URL so browser-back restores it
        let query = {...this.$route.query}
        if (newValue > 1) query.page = newValue
        else delete query.page
        this.$router.replace({query}).catch(() => {})
      },
    },
  },

  created() {
    if (this.$route.query.search) {
      this.filter.search = this.$route.query.search
    }
    if (this.$route.query.company__name__gt) {
      this.filter.company__name__gt = this.$route.query.company__name__gt
    }
    if (this.$route.query.visits) {
      this.filter.visits = true
    }
    if (this.$route.query.favorites) {
      this.filter.favorites = "1"
    } else if (this.favoriteMode) {
      this.filter.favorites = "1"
    }

    this.fetchExhibitors({page: this.page, ...this.filter})
  },

  methods: {
    onSearchChanged: function (search) {
        this.currentNode = null
        if (search) this.$set(this.filter, 'search', search)
        else this.$delete(this.filter, 'search')
    },

    toggleVisits(active) {
      if (active && !this.numVisitedExhibitors)
        return
      this.$delete(this.filter, 'favorites')
      this.$delete(this.filter, 'search')
      if (active)
        this.$set(this.filter, 'visits', active)
      else
        this.$delete(this.filter, 'visits')
    },

    resetFilter: function () {
      this.$delete(this.filter, 'search')
      this.currentNode = null
    },

    showDescription: function(exhibitor) {
      this.$set(exhibitor, 'show_desc',  exhibitor.show_desc == undefined ? 1 : !exhibitor.show_desc)
    },

    fetchExhibitors: function (filter) {
      let me =  this
      let params = {...filter}
      let payload = {}
      if (this.favoriteMode) {
        if (this.getFavorites().length < 1) {
          me.exhibitors = []
          me.numExhibitors = 0
          me.numPages = 1
          return
        }
      } else {
        params.event__short_name = this.eventShortName.toUpperCase()
        if (params.favorites) {
          delete params.favorites
          payload.sfid = this.getFavorites()
        }
      }
      if (navigator.onLine) {
        if (this.favoriteMode || params.favorites === "1") {
          payload.sfid = this.getFavorites()
          delete params.favorites
        }
        me.loading = true
        return this.$api.post(`/${this.itemKey}/`, payload, {params: params,}).then(
          response => {
          me.exhibitors = response.data.results
          me.numExhibitors = response.data.count
          me.numVisitedExhibitors = response.data.num_visited_exhibitors
          me.numPages = response.data.num_pages
          return response
        }).finally(() => { me.loading = false })
      } else {
        let exhibitors = this.$storage.getItem(this.itemKey, {})
        me.exhibitors = Object.values(exhibitors)
        me.numExhibitors = me.exhibitors.length
        me.numPages = 1
      }
    },

    exportList: function() {
      if (this.exhibitors.length > 200)
        alert('Export ist limitiert auf 200 Aussteller.')
      let sfids = this.exhibitors.map(exhibitor => exhibitor.sfid).slice(0, 200).join(',')
      const url = `${this.$backendUrl}api/print-exhibitors/?sfid=${sfids}`
      window.open(url, '_blank')
    },

    onFilterValue: function (value) {
      this.filter.search = ''
      this.$delete(this.filter, 'search')
      if (value) {
        if (value == '#') value = '0'
        this.$set(this.filter, 'company__name__gt', value)
      } else
        this.$delete(this.filter, 'company__name__gt')
    },

  },
}
</script>

<template>
  <div>
    <exhibitor-navbar class="mb-1"
      :filter="filter"
      fav-key="sfid"
      :fav-mode="favoriteMode"
      :visits-active="visitsActive"
      :num-visits="numVisitedExhibitors"
      @search="onSearchChanged($event)"
      @delete-search="resetFilter()"
      @on-filter-value="onFilterValue($event)"
      @toggle-favorites="toggleFavorites($event)"
      @toggle-visits="toggleVisits($event)"
      @export-list="exportList()"
    />

    <ol class="breadcrumb bg-white ps-0">

      <li class="breadcrumb-item active">
        {{numFavorites}} Favoriten / {{numVisitedExhibitors}} Standbesuche / {{numExhibitors}} Treffer
      </li>
      <li v-if="this.filter.company__name__gt" class="breadcrumb-item active">
        <a class="badge badge-pill bg-primary me-1" style="text-decoration:none"
         @click.prevent="onFilterValue()">
         <b>{{ this.filter.company__name__gt }}&nbsp;</b>
         <i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="favActive" class="breadcrumb-item active">
        <a class="badge badge-pill bg-warning me-1" style="text-decoration:none"
         @click.prevent="toggleFavorites()">
         <b>Favoriten&nbsp;</b>
         <i class="far fa-times-circle"></i>
        </a>
      </li>
      <li v-if="visitsActive" class="breadcrumb-item active">
        <a class="badge badge-pill bg-warning me-1" style="text-decoration:none"
         @click.prevent="toggleVisits()">
         <b>Standbesuche&nbsp;</b>
         <i class="far fa-times-circle"></i>
        </a>
      </li>
    </ol>

    <div v-if="loading" class="text-center my-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <span v-else-if="exhibitors.length > 0">
      <div v-for="exhibitor in exhibitors" :key="exhibitor.id">
        <exhibitor-row :exhibitorType="exhibitorType" :exhibitor="exhibitor"
         :listDisplay="listDisplay" @favorite-changed="getFavorites" />
        <hr/>
      </div>

      <pagination-buttons :page.sync="page" :num-pages="numPages" />
    </span>
    <div v-else class="mb-3">
      <div class="text-center">-- keine Treffer --</div>
    </div>
  </div>

</template>

<style scoped>
.breadcrumb-item a {
  text-decoration: none;
  font-size: 90%;
}

.no-deco {
  text-decoration: none;
}
</style>